import { render, staticRenderFns } from "./SettingsContact.vue?vue&type=template&id=330e60ac&scoped=true&"
import script from "./SettingsContact.vue?vue&type=script&lang=js&"
export * from "./SettingsContact.vue?vue&type=script&lang=js&"
import style0 from "./SettingsContact.vue?vue&type=style&index=0&id=330e60ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330e60ac",
  null
  
)

export default component.exports